import React, { useState } from 'react';
import { feedbackDropdown } from "../Components/DropdownNavItems"
import { Link } from 'react-router-dom';
import "../index.css"

const FeedbackDropdown = () => {
    const [dropDown, setDropDown] = useState(false)
    return (
        <div>
            <>
                <ul className={dropDown ? "feedback-submenu clicked": "feedback-submenu"} onClick={() => setDropDown(!dropDown)}>
                    {
                        feedbackDropdown.map(item => {
                            return (
                                <li key={item.id}>
                                    <Link to={item.path} className={item.cName} onClick={() => setDropDown(false)}>{item.title}</Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </>
        </div>
    );
}

export default FeedbackDropdown;
